import React from "react";
import "./SearchBar.scss";

const SearchBar = ({ onSearch, searchTerm }) => {
  return (
    <div className="search-container">
      <div className="search-wrapper">
        <div className="icon-circle">
          {/* Magnifying Glass SVG */}
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#d35400"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="8"></circle>
            <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          </svg>
        </div>
        <input
          type="text"
          className="search-input"
          placeholder="Search by name or phone..."
          onChange={onSearch}
          value={searchTerm}
        />
      </div>
    </div>
  );
};

export default SearchBar;
